module.exports = __webpack_public_path__ + "img/vmwarelogo.80b81252.png";